import { $ } from 'hanako-ts/dist-legacy/Framework';
export class Dropdown {
    constructor(HTMLElement) {
        this.HTMLElement = HTMLElement;
    }
    slideDown() {
        this.HTMLElement.style.maxHeight = $(this.HTMLElement).find('.content').get(0).scrollHeight + 'px';
    }
    slideUp() {
        this.HTMLElement.style.maxHeight = '0';
    }
    toggle() {
        if (this.HTMLElement.style.maxHeight == '' || this.HTMLElement.style.maxHeight == '0px') {
            this.slideDown();
        }
        else {
            this.slideUp();
        }
    }
}
